<template>
<v-app class="survey-container">

    <v-layout class="bg-light-blue" row wrap>
      <v-flex xs12>
        <NavBarHome></NavBarHome>
      </v-flex>
      <v-flex xs12>
        <v-banner v-if="impersonation" class="impersonation-banner yellow lighten-2">
        <v-avatar
          slot="icon"
          color="deep-orange accent-4"
          size="40">
          <v-icon color="white">
          people_alt
          </v-icon>
        </v-avatar>
        You are viewing the survey of <strong>{{officeDescription}}</strong>.
        <template v-slot:actions>
          <v-btn color="deep-orange accent-4 white--text" @click="exit()">Exit</v-btn>
        </template>
       </v-banner>
        <div class="content">
          <h1>Submit Survey : {{FYVolume}}</h1>

          <p class="content-detail">
            Are you sure you're ready to submit? This will lock the survey from any future updates unless you contact Technical Support to unlock the survey.
            <ul>
              <li>If no, click the Cancel button below to return to the survey.</li>
              <li>If yes, enter the data below and click the Submit Survey button. <u>Warning: It might be best to return to the survey first and save each question one more time.</u></li>
            </ul>
          </p>

          <v-layout row wrap mt-5>
              <v-flex class="content-box elevation-1" xs6>

                <div class="content-detail">Approximately how many person hours were required to complete the online Survey of Federal Funds Survey for R&D?</div>

                <p v-if="errors.length">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                  </ul>
                </p>

                <v-flex xs2>
                  <v-text-field
                    id="personHours"
                    v-model="personHours"
                    height="24"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
										maxlength = "3"
                    hint="person hours"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                <div class="content-detail"><span v-if="errorInfo !== null">{{errorInfo}}</span></div>
                <br/>
                </v-flex>

                <v-flex xs12>
                &nbsp;<span style="color:blue;">{{message}}</span>&nbsp;
                <v-btn normal :loading="isLoading" :class="isSurveyLocked"
                  class="primary darken-2 white--text"
                  @click="checkForm" :disabled="isLocked"
                >Submit Survey </v-btn>
                <v-btn normal
                  class="blue-button btnOffset"
                  @click="cancelForm"
                >Cancel</v-btn>
                </v-flex>

              </v-flex>

          </v-layout>

        </div>
				<div class="content">
					<!--<p><span class="col-orange">
					<b>Warning:</b> Currently, there is an issue with the e-mail system that is affecting submission e-mails. If the system stays at the submission page and you are not sure if the survey was submitted, please return to the landing page. If there is a statement that the survey has been submitted, you are done. We will alert offices that have submitted when the problem is solved. At that time, if you want to get a submission e-mail, we will unlock your survey, so you can resubmit. We apologize for the inconvenience and thank you for your cooperation.
				</span></p>-->
				</div>
      </v-flex>
    </v-layout>

    <Footer></Footer>

</v-app>
</template>

<script>
// @ is an alias to /src
import { CONSTANTS } from '@/common/constants.js';
import { authTokenService } from '@/services/authTokenService.js';
import router from '@/router';
// eslint-disable-next-line no-unused-vars
import { NavBarHome } from '@/components/NavBarHome.vue';
import { surveyService } from '@/services/surveyService';
import { userService } from '@/services/userService';
import cellErrorHighlightMixin from '../components/answers/mixins/cellErrorHighlightMixin.js';
import { officeManagementService } from "@/services/officeManagementService.js";

export default {
  name: 'SurveySubmit',
  mixins: [cellErrorHighlightMixin],
  props: {
    value: Number,
    errorInfo: String
  },
  data: () => ({
    requiredSizeOnLoad: 0,
    v: Boolean,
    activeId: null,
    request: null,
    errors: [],
    personHours: null,
    message: null,
    isSurveyLocked: null,
    FYVolume: null,
    isLocked: null,
    impersonation: false,
    officeDescription: '',
    // eslint-disable-next-line no-dupe-keys
    activeId: null,
    claims: null
  }),
  mounted () {
    const me = this;
    me.FYVolume = authTokenService.getFYVolume();
    me.activeId = authTokenService.getActiveSurveyId();
    me.claims = authTokenService.getClaims();
    if (me.claims.userName == "Admin") {
      authTokenService.setNotaAdmin(false);
    }
    me.nonAdmin = authTokenService.getNotaAdmin();
    if (me.nonAdmin != "true") {
      if (me.claims.role != undefined && me.claims.role.includes('Admin')) {
        me.impersonation = true;
      } else if (me.claims.surveyId != undefined && typeof me.claims.surveyId === 'string') {
        me.impersonation = me.claims.surveyId !== me.activeId;
      } else if (me.claims.surveyId != undefined && typeof me.claims.surveyId === 'object') {
        me.impersonation = !me.claims.surveyId.includes(me.activeId);
      }
      officeManagementService.getOfficeBySurveyId(me.activeId).then(function (response) {
        if (response && response.data) {
          me.officeDescription = response.data.description;
          me.officeId = response.data.id;
        }
		  });
		}
      surveyService.getLockStatus(me.activeId).then(function (response) {
				if (response && response.data != null) {
					me.personHours = response.data.completionTime;
					if (response.data.isLocked == true) {
							me.isLocked = true;
              me.isSurveyLocked = "isDisabled";
						  me.lockMessage = "This survey has been submitted and locked."
					} else if (response.data.currentUser != null) {
						me.isLocked = true;
						me.lockMessage = `The survey is in use by user: ${response.data.currentUser}`;
					} else {
            me.isSurveyLocked = null;
						me.lockMessage = null;
            me.isLocked = false;
					}
				}
			});
  },
  methods: {
    exit () {
      let name = this.previousComponentName;
      let params = {};
      if (name == 'details') {
        params = { id: this.officeId, surveyId: this.activeId };
        router.push({ name: name, params: params });
      } else { router.push({ name: 'admin.stats' }); }
    },
    checkForm (e) {
      this.claims = authTokenService.getClaims();
      if (this.claims.userName == "Admin") {
        this.message = "Functionality not implemented to submit survey by Admin";
        return;
      }
      if (this.personHours == null || this.personHours == '0' || this.personHours == '00' || this.personHours == '000' || this.personHours == '') {
        this.message = "Please enter total hours spent on this survey";
        return;
      }
      const activeSurveyId = authTokenService.getActiveSurveyId();

      this.message = "Submission is in process. You should receive an e-mail shortly saying your survey is submitted.";

			if (this.personHours && this.isSurveyLocked == null) {
				this.isSurveyLocked = "isDisabled";
        let surveyStatus = this.$store.getters["validation/surveyStatus"];
        if (surveyStatus == CONSTANTS.SURVEY_STATUS.COMPLETE || surveyStatus == CONSTANTS.SURVEY_STATUS.IN_PROGRESS || surveyStatus == CONSTANTS.SURVEY_STATUS.WARNINGS) {
          surveyStatus = CONSTANTS.SURVEY_STATUS.SUBMITTED;
					this.personHours = Math.round(this.personHours);
          let request = {
            "status": "Submitted",
						"completionTime": this.personHours,
						"isLocked": true
          }
          surveyService.updateSurveyStatus(activeSurveyId, request).then(function (response) {
            console.log('Survey Status now updated to \'Submitted\' ');
            router.push({ name: 'surveysubmitted' });
          }).catch(function (error) {
            console.error('Survey Status update to \'Submitted\' has failed.');
            console.error(error);
				 });
        } else if (surveyStatus == CONSTANTS.SURVEY_STATUS.NOT_STARTED) {
					this.message = null;
          this.errorInfo = 'The survey has not been initiated, please address all the questions before submitting.';
				} else if (surveyStatus == "Submitted" || surveyStatus == null) {
					this.message = null;
          this.errorInfo = 'This survey previous status has been cached, please click SAVE either of one survey question, to processed further.';
				}	else {
					this.message = null;
          this.errorInfo = 'The survey cannot be submitted. Because there are errors. Click the Cancel button below, then correct the data on the questions with errors. Save each question and resubmit the survey.';
        }
      }

      this.errors = [];
      if (!this.personHours) {
        console.log('Required number: ' + this.personHours);
        this.errors.push('Number of person hours required.');
      }
      e.preventDefault();
    },
    cancelForm () {
      router.push({ name: 'home' });
    },
	disableInCaseOfPreviousVolume: function () {
			debugger;
			const me = this;
			const cVolume = authTokenService.getCurrentVolume();
			userService.getVolumeConfig().then(function (response) {
			if (response && response.data != null) {
				if (response.data.volume !== cVolume) {
					me.isLocked = true;
					me.isSurveyLocked = "true";
				} else {
					me.isLocked = false;
					me.isSurveyLocked = "false";
				}
			}
		});
		return me.isLocked;
	}
  },
  computed: {
    ctrlId: function () {
      return this.name + '_' + this.index;
    },
    prefixValue: function () {
      return !this.prefix ? '' : this.prefix;
    },
    cellValue: function () {
      return !this.theValue ? '' : this.theValue.strValue;
		}
  }
}
</script>

<style scoped>
.col-orange {
  color: #c1560e;
  font-weight: bold;
}
.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}
.survey-container  {
  width: 100%;
  margin: 0 auto;
}
.content {
  padding: 3% 3% 3% 5%;
  text-align: left;
}
.content-header {
  font-weight: bold;
}
.content-detail {
  font-weight: normal;
}
.v-text-field >>> input {
  text-align: left;
  padding: 3px;
  min-width: 150px;
}
h1 {
  margin: 20px 0 !important;
  padding: 0 !important;
  border: none !important;
  font-size: 20pt;
  font-style: normal;
  font-weight: bold;
}
h2 {
  font-size: 16pt;
  font-weight: normal;
}
h3 {
  font-size: 14pt;
  font-weight: normal;
  color: #c55911;
}
a {
  font-weight: bold;
}
.content-box {
  background-color: #ececec;
  border: 1px solid #e0dede;
  padding: 2% 2% 1% 2%;
  margin-bottom: 0%;
  border-radius: 5px;
  border: 1px solid #13314f;
}
v-btn >>> button{
  margin-top: 100px;
}
button.btnOffset {
  margin-left: 25px;
}
</style>
